// material-ui
import { Box } from '@mui/material';

// project import
import MainCard, { MainCardProps } from 'ui-component/cards/MainCard';

// ==============================|| AUTHENTICATION CARD WRAPPER ||============================== //

const AuthCardWrapper = ({ children, ...other }: MainCardProps) => (
    <MainCard
        sx={{
            position: 'relative',
            border: { xs: 'solid 1px transparent' },
            backgroundColor: '#00000088',
            zIndex: 10,
            width: '100%',
            margin: { xs: 2.5, md: 3 },
            '& > *': {
                flexGrow: 1,
                flexBasis: '50%'
            }
        }}
        content={false}
        {...other}
    >
        <Box sx={{ p: { xs: 5, sm: 5, xl: 5 } }}>{children}</Box>
    </MainCard>
);

export default AuthCardWrapper;
